/* Pack-specific media rendered by Liquid; Emerge keeps thumbnails, zoom and carousel behavior. */
if (!customElements.get('yunsho-pack-gallery')) {
  customElements.define('yunsho-pack-gallery', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.main-product--root');
      const picker = this.root?.querySelector('product-options-element');
      if (!picker) return;
      this.regionSelectors = ['.main-product--media', '.main-product--desktop', '.main-product--mobile'];
      this.cache = new Map([[this.dataset.selectedVariant, this.captureRegions(this.root)]]);
      this.sequence = 0;
      this.eventName = `theme:product:${picker.dataset.id}:variantChanged`;
      this.onVariant = ({detail}) => this.updateGallery(String(detail.variant?.id || ''));
      window.addEventListener(this.eventName, this.onVariant);
    }
    disconnectedCallback() {
      window.removeEventListener(this.eventName, this.onVariant);
      this.controller?.abort();
    }
    captureRegions(root) {
      return this.regionSelectors.map(selector => ({
        selector,
        html: root.querySelector(selector)?.innerHTML ?? null
      })).filter(region => region.html !== null);
    }
    async updateGallery(variantId) {
      if (!variantId) return;
      const sequence = ++this.sequence;
      this.controller?.abort();
      this.root.dataset.packLoading = 'true';
      try {
        if (!this.cache.has(variantId)) {
          this.controller = new AbortController();
          const url = new URL(this.dataset.productUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionKey);
          url.searchParams.set('variant', variantId);
          const response = await fetch(url, {signal: this.controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error(`Gallery response ${response.status}`);
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = parsed.querySelector('.main-product--root[data-pack-gallery="true"]');
          if (!root) throw new Error('Pack gallery missing from section response');
          this.cache.set(variantId, this.captureRegions(root));
        }
        if (sequence !== this.sequence || !this.isConnected) return;
        const replacements = this.cache.get(variantId).map(region => {
          const target = this.root.querySelector(region.selector);
          const template = document.createElement('template');
          template.innerHTML = region.html;
          return {target, content: template.content};
        }).filter(region => region.target);
        // Disconnect every old gallery before connecting replacements: native listeners share the product id.
        replacements.forEach(({target}) => target.replaceChildren());
        replacements.forEach(({target, content}) => target.append(content));
        this.root.removeAttribute('data-pack-gallery-error');
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === this.sequence) {
          this.root.dataset.packGalleryError = 'true';
          console.warn('Pack gallery could not refresh.', error);
        }
      } finally {
        if (sequence === this.sequence) this.root.removeAttribute('data-pack-loading');
      }
    }
  });
}
